import React from "react";
import styled from "styled-components";

const ContentStyle = styled.div`
    flex-grow: 1;
    position: relative;
    vertical-align: top;
    background-color: ${props => props.theme.greyLightest};
`;

export const Content = ({ children }) =>
    <ContentStyle>
        <div>
            {children}
        </div>
    </ContentStyle>;